import React from 'react';
import PropTypes from 'prop-types';
import ComponentsFactory from 'foundation/components-factory';
import { SchemaOrg } from 'project/schema-org';

import { ContentType } from 'components/content-type';
import { mediaTypes } from 'components/posts';

class NewsCard extends React.Component {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
    }

    componentDidMount() {
        ComponentsFactory.getInstance().init(this.rootRef.current);
    }

    componentWillUnmount() {
        ComponentsFactory.getInstance().destroy(this.rootRef.current);
    }

    onClickRoot = () => {
        const { onCardLinkClick, model } = this.props;
        onCardLinkClick(model);
    }

    getFullTitle() {
        const { title, subtitle } = this.props.model;
        return title + (subtitle ? ` / ${subtitle}` : '');
    }

    getTrackingCategory(contentType) {
        switch (contentType) {
            case mediaTypes.VIDEO_PLAYER:
                return 'Video Player';
            case mediaTypes.GALLERY:
                return 'Gallery';
            default:
                return 'Article';
        }
    }

    renderContentType(model) {
        if (model.type === mediaTypes.GALLERY ||
            model.type === mediaTypes.VIDEO_PLAYER
        ) {
            return (
                <div className="news-card__content-type">
                    <ContentType type={model.type} />
                </div>
            );
        }

        return null;
    }

    render() {
        const { model, bemModifiers } = this.props;
        let bemCss = '';

        if (Array.isArray(bemModifiers)) {
            bemCss = bemModifiers.map((x) => `news-card--${x}`).join(' ');
        }

        return (
            <a
                className={`news-card ${bemCss}`}
                href={model.url}
                ref={this.rootRef}
                onClick={this.onClickRoot}
            >
                <div className="news-card__background">
                    <img
                        className="lazyload predefined-size"
                        data-srcset={model.bgImage}
                        alt=""
                        data-sizes="auto"
                    />
                    {this.renderContentType(model)}
                </div>
                <div className="news-card__content-wrapper">
                    <div className="news-card__content">
                        <p className="news-card__label">{model.label}</p>
                        <h3 className="news-card__title-wrapper">
                            <b className="news-card__title">{model.title}</b>
                            <span className="news-card__separator">/</span>
                            <span className="news-card__subtitle">{model.subtitle}</span>
                        </h3>
                        <div className="news-card__cta-text-wrapper">
                            <span className="news-card__cta-text">{model.ctaText}</span>
                            <svg className="news-card__cta-text-icon icon" width="14" height="12"
                                focusable="false">
                                <use xlinkHref="#icon-arrow-right"></use>
                            </svg>
                        </div>
                    </div>
                </div>
                <SchemaOrg model={model.schemaOrg} />
            </a>
        );
    }
}

NewsCard.propTypes = {
    model: PropTypes.object.isRequired,
    bemModifiers: PropTypes.array,
    onCardLinkClick: PropTypes.func,
};

export default NewsCard;
